import React, { useEffect, useState } from 'react';
import { pluralizeSeconds } from 'src/utils/pluralizeUtils';
import styled from 'styled-components';
import { Description } from '../Description';

import { Title } from '../Title';

export const LogOutForm = () => {
  const [secondsLeft, setSecondsLeft] = useState(5);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (secondsLeft > 0) {
        setSecondsLeft((prevState) => prevState - 1);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  return (
    <Wrapper>
      <Title>Выход из системы выполнен</Title>
      <Description>
        Окно закроется автоматически через
        {` ${secondsLeft} ${pluralizeSeconds(secondsLeft)}`}
      </Description>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
